import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, styled, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";

import { imagesList } from "../../constants";
import { useMobile } from "../../utils/findViewport";

const CustomTopBanner = styled(Box)(({ theme }) => ({
  ".top-banner-box": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#EAF2FF",
    padding: "0px 24px 24px 100px",
  },
  ".head-text": {
    fontSize: "48px",
    fontWeight: "600",
  },
  ".secondary-text": {
    fontSize: "28px",
    fontWeight: "400",
  },
  ".image-section": {
    objectFit: "contain",
    width: "100% !important",
    position: "relative !important",
  },
  [theme.breakpoints.down("md")]: {
    ".top-banner-box": {
      background: "#EAF2FF",
      padding: "16px 10px 36px 12px",
    },
    ".head-text": {
      fontSize: "16px",
    },
    ".secondary-text": {
      fontSize: "10px",
    },
  },
}));

const TopBanner = ({ location, vehicleName }) => {
  const mobile = useMobile();
  return (
    <CustomTopBanner>
      <Box className="top-banner-box">
        <Box>
          <Box>
            <Typography variant="h1" className="head-text">
              {vehicleName}{" "}
              <span style={{ color: "#35BF68" }}>
                {mobile ? (
                  <LocationOnIcon style={{ fontSize: "14px" }} />
                ) : (
                  <LocationOnIcon style={{ fontSize: "38px" }} />
                )}
                {location}
              </span>
            </Typography>
          </Box>
          <Box>
            <Typography className="secondary-text">
              Find the right electric three wheeler for your business
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            width: { xs: "25%", md: "20%" },
            minHeight: { xs: "70px", md: "200px" },
            float: "right",
          }}
        >
          <Image
            alt="piaggio-ape charging"
            src={imagesList.charging}
            layout="fill"
            className={"image-section"}
          />
        </Box>
      </Box>
    </CustomTopBanner>
  );
};

export default TopBanner;
